import { CardActionArea } from "@mui/material";

export function MapsButton({
  action,
  children,
}: {
  action: any;
  children: any;
}) {
  return (
    <div className="rounded-all-normal overflow-all-hidden">
      <CardActionArea>
        <div
          className="pointer  bg-surface flex justify-content-center align-items-center p-normal"
          onClick={() => action()}
        >
          {children}
        </div>
      </CardActionArea>
    </div>
  );
}
